module.exports = __webpack_public_path__ + "media/images/banner-assets/en/banner3-986cf3d0a75005c374578e0acb96d6d1.jpg";